import type { Routes } from '@angular/router';
import {LoginComponent} from '@pages/login/login.component';
import {authUserGuard} from '@entities/auth/guards/access-guard';
import {
  ROUTE_HOME,
  ROUTE_ADDRESS,
  ROUTE_FORGOT_PASSWORD,
  ROUTE_LOGIN,
  ROUTE_ORDER_HISTORY, ROUTE_REGISTER
} from '@shared/utils/vars';
import {TAuthModal} from '@features/itc-auth-page/itc-auth-page';

/**
 * Get auth page route
 * @param path
 * @param type
 */
const getAuthPage = (path: string, type: TAuthModal) => {
  return {
    path,
    component: LoginComponent,
    data: { type }
  }
}

export const routes: Routes = [
  getAuthPage(ROUTE_LOGIN, 'login'),
  getAuthPage(ROUTE_REGISTER, 'register'),
  getAuthPage(ROUTE_FORGOT_PASSWORD, 'reset-password'),
  {
    path: ROUTE_HOME,
    canActivate: [authUserGuard],
    loadComponent: () => import('@widgets/main-layout/main-layout').then(m => m.MainLayout),
    children: [
      {
        path: '',
        loadComponent: () => import('@pages/profile/profile.component').then(m => m.ProfileComponent),
      },
      {
        path: ROUTE_ADDRESS,
        loadComponent: () => import('@pages/addresses/addresses.component').then(m => m.AddressesComponent),
      },
      {
        path: ROUTE_ORDER_HISTORY,
        loadComponent: () => import('@pages/orders/orders.component').then(m => m.OrdersComponent),
      }
    ]
  },
  {path: ROUTE_HOME + '/', redirectTo: ROUTE_HOME, pathMatch: 'full' },
  {path: '', redirectTo: ROUTE_HOME, pathMatch: 'full'},
  {path: '**', redirectTo: ROUTE_HOME}
];
